'use strict';

const { pubdb } = Function('return this')();
const { ajax_get, ajax_post, multi_prompt, echo } = pubdb;


const SEP_SERVER_ERROR = {};

function sep_verify (cb) {
    ajax_get(
        `${pubdb.path_root}/sep/verify/`,
        ({success, name}) => {
            if (success) {
                cb(name);
            } else {
                cb();
            }
        },
        () => { cb(SEP_SERVER_ERROR) },
    );
}

function do_login (username, password, cb) {
    function on_error () {
        echo('warn', 'Die Anmeldung konnte aufgrund eines unbekannten Serverfehlers nicht durchgeführt werden.');
        cb(SEP_SERVER_ERROR);
    }

    function on_data ({success, reason, errors, name, csrf_token}) {
        if (csrf_token) {
            pubdb.csrf_token = csrf_token;
        }

        if (!success) {
            echo('warn', {
                'form': 'Die eingegebenen Login-Daten hatten ein ungültiges Format.',
                'ldap': 'Es konnte keine Verbindung zum LDAP-Server hergestellt werden.',
                'credentials': 'Die von Ihnen angegebenen Login-Daten waren fehlerhaft.',
            }[reason] || reason);
            cb();
        } else {
            echo('confirm', `Sie sind jetzt als „${name}“ angemeldet.`);
            cb(name);
        }
    }

    ajax_post(
        `${pubdb.path_root}/sep/login/`,
        { username, password, csrf_token: pubdb.csrf_token },
        on_data, on_error,
    );
}

function sep_login (cb) {
    multi_prompt(
        'Anmelden bei SEP',
        'Sie müssen sich erneut einloggen, um Publikationen nach SEP übertragen zu können. ' +
        'Das Konto bei SEP muss nicht notwendigerweise dasselbe wie bei der Anmeldung in der PubDB sein.',
        [
            {label: 'Benutzername:'},
            {label: 'Passwort:', type: 'password'},
        ],
        [
            ['anmelden', (username, password) => { do_login(username, password, cb) }],
            ['abbrechen', () => { cb() }],
        ],
    );
}

function sep_ensure (cb) {
    sep_verify(name => {
        if (!name) {
            sep_login(cb);
        } else {
            if (name !== SEP_SERVER_ERROR) {
                echo('confirm', `Sie sind als „${name}“ angemeldet.`);
            }
            cb(name);
        }
    });
}


pubdb.SEP_SERVER_ERROR = SEP_SERVER_ERROR;
pubdb.sep_ensure = sep_ensure;
